// extracted by mini-css-extract-plugin
export default {"container":"Label_container__UButg","labelText":"Label_labelText__MAlSk"};